import React, { useState, useEffect, useCallback } from 'react';
import { getSnapshots, deleteSnapshot } from '../utils/api';

export default function SnapshotHistory({ onView }) {
  const [items, setItems] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);

  const load = useCallback(async (c) => {
    setLoading(true);
    try {
      const res = await getSnapshots(c);
      setItems(prev => c ? [...prev, ...res.items] : res.items);
      setCursor(res.cursor);
      setHasMore(!!res.cursor);
    } catch (err) { console.error(err); }
    setLoading(false);
  }, []);

  useEffect(() => { load(null); }, [load]);

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this snapshot?')) return;
    await deleteSnapshot(id);
    setItems(prev => prev.filter(i => i.snapshotId !== id));
  };

  return (
    <div>
      <h2 style={{ margin: '0 0 16px' }}>📋 Curation History</h2>
      {items.length === 0 && !loading && <p style={{ color: '#666' }}>No saved curations yet. Curate news from a dashboard to create snapshots.</p>}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
        {items.length > 0 && (
          <thead>
            <tr style={{ background: '#f0f0f0', textAlign: 'left' }}>
              <th style={{ padding: 8 }}>Dashboard</th>
              <th style={{ padding: 8 }}>Industry</th>
              <th style={{ padding: 8 }}>Date Range</th>
              <th style={{ padding: 8 }}>Items</th>
              <th style={{ padding: 8 }}>Created</th>
              <th style={{ padding: 8, width: 120 }}>Actions</th>
            </tr>
          </thead>
        )}
        <tbody>
          {items.map(s => (
            <tr key={s.snapshotId} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: 8, fontWeight: 500 }}>{s.dashboardName}</td>
              <td style={{ padding: 8, color: '#666', fontSize: 13 }}>{s.industry}</td>
              <td style={{ padding: 8, fontSize: 13 }}>{s.startDate} → {s.endDate}</td>
              <td style={{ padding: 8, textAlign: 'center' }}>{s.itemCount}</td>
              <td style={{ padding: 8, fontSize: 12, color: '#666' }}>{s.createdAt?.slice(0, 16).replace('T', ' ')}</td>
              <td style={{ padding: 8 }}>
                <button onClick={() => onView(s.snapshotId)}
                  style={{ padding: '3px 10px', background: '#0073bb', color: '#fff', border: 'none', borderRadius: 3, cursor: 'pointer', fontSize: 12, marginRight: 4 }}>
                  View
                </button>
                <button onClick={() => handleDelete(s.snapshotId)}
                  style={{ padding: '3px 10px', background: '#d13212', color: '#fff', border: 'none', borderRadius: 3, cursor: 'pointer', fontSize: 12 }}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {hasMore && (
        <button onClick={() => load(cursor)} disabled={loading}
          style={{ marginTop: 12, padding: '6px 16px', background: '#545b64', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
          {loading ? 'Loading...' : 'Load More'}
        </button>
      )}
      {loading && items.length === 0 && <p>Loading...</p>}
    </div>
  );
}
